/*
  isLocalStorageSupported.js
*/

let _isSupported = null;

/**
 * Helper to check if localStorage is supported.
 */
export default function isLocalStorageSupported() {

  if (_isSupported == null) {
    try {
      const test = '__test__';
      localStorage.setItem(test, test);
      localStorage.removeItem(test);
      _isSupported = true;
    } catch (e) {
      _isSupported = false;
    }
  }

  return _isSupported;

}
